<template>
  <div role="dialog" class="popup fadein absolute h-full w-full z-50 flex justify-center items-center">
    <div class="popup-wrapper z-50 w-1/3 max-w-md flex flex-row-reverse rounded-xl bg-slate-middle">
      <div
        tabindex="0"
        ref="firstFocus"
        class="absolute h-6 w-6 mr-2 mt-3 p-1.5 bg-black rounded-full flex justify-center items-center cursor-pointer"
        @pointerup="close()"
        @keydown.enter="close()"
      >
        <img class="w-5 h-5 invert rotate-45" :src="Close" />
      </div>
      <div class="flex flex-col justify-between w-full h-full px-9 py-9 font-thin bg-slate-middle rounded-xl mt-3">
        <p class="text-2xl font-bold text-slate-white mb-5">{{ t('headline') }}</p>
        <Notice :type="DialogMessageType.Error" :text="props.text" />
        <div class="pt-5 flex justify-between items-center w-full">
          <button class="gray-btn cursor-pointer p-3 px-5 text-md text-slate-white" @pointerup="close()">{{ t('back') }}</button>
          <button class="red-btn cursor-pointer p-3 px-5 text-md text-slate-white" @pointerup="confirm()">{{ t('confirm') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { DialogMessageType, Wall } from '@/common/classes'

  import Notice from '@/components/dialog/Notice.vue'
  import Close from './../../assets/icons/fontawesome/plus-solid.svg'
  import { nextTick, onMounted, ref } from 'vue'

  const messages = {
    no: {
      headline: 'Vil du gå videre?',
    },
    en: {
      headline: 'Do you want to continue?',
    },
  }

  const emit = defineEmits<{
    (e: 'closePopup'): void
    (e: 'confirm', wall?: Wall): void
  }>()

  const { t } = useI18n({ messages })

  const props = defineProps({
    text: { type: String, required: true },
  })
  const firstFocus = ref()

  onMounted(() => nextTick(() => firstFocus.value?.focus()))

  function close() {
    emit('closePopup')
  }

  function confirm() {
    emit('confirm')
    close()
  }
</script>

<style scoped></style>
